import { render } from "./TemperatureDisplay.vue?vue&type=template&id=c0bb3f1e"
import script from "./TemperatureDisplay.vue?vue&type=script&lang=js"
export * from "./TemperatureDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__